import { useClipboard as useVueUseClipboard } from "@vueuse/core";
import { Notify } from "quasar";
import { computed } from "vue";

export default function useClipboard() {
  const { copied, copy } = useVueUseClipboard({ copiedDuring: 1500 });

  function copyToClipboard(data: string): void {
    copy(data);

    Notify.create({
      color: "green",
      message: "Copied to clipboard!",
    });
  }

  const copyIcon = computed<string>(() =>
    copied.value ? "check" : "file_copy"
  );

  return {
    copyIcon,
    copyToClipboard,
  };
}
